/** Escopos de visibilidade da listagem de usuários. Sem escopo, o backend aplica o escopo de acesso padrão. */
export enum EnumUsuarioEscopo {
  VINCULO = 'vinculo'
}
